export class ContactType {

    ctp_id: string;
    ctp_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.ctp_id         = data['ctp_id'] ? data['ctp_id'] : null;
        this.ctp_libelle    = data['ctp_libelle'] ? data['ctp_libelle'] : null;
    }

}
